<template>
  <div class="my-header-menu">
    <div class="my-header-menu-left">
      <div class="logo">
        <a v-if="$store.state.show_menu!==1" @click="routerTo(1,0,'/')">
          <img src="../../assets/logo_all.png" style="height:50px" >
        </a>
      </div>
    </div>
    <div class="my-header-menu-right">
      <div style="font-size: 30px;">我在 <span style="color: #f56c6c;font-weight: bolder">{{uploadType}}</span> !!!</div>
      <div v-if="$store.state.user_info.group_id===1">
      <el-button type="danger" size="small" @click="routerTo(1,0,'/user/user_ads_mouth_data')">
        当月数据
      </el-button>
      <el-button type="success" size="small" @click="routerTo(1,0,'/user/user_ads_data')">
        汇总数据
      </el-button>
      </div>
      <el-dropdown trigger="click" class="color-primary" style="margin-left: 10px">
        <span class="el-dropdown-link" style="cursor: pointer">
          <img v-if="$store.state.source_host&&$store.state.user_info.thumb" :src="$store.state.user_info.thumb.indexOf('http')!=-1?$store.state.user_info.thumb:($store.state.source_host+$store.state.user_info.thumb)" style="float: left;width: 45px;height: 45px;border-radius:50%;margin-right: 10px">
          <span style="line-height: 45px">
            {{$store.state.user_info.name}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        </span>
        <el-dropdown-menu slot="dropdown">
<!--          <el-dropdown-item @click.native="routerTo(1,0,'/user/user_ads_data')">个人数据</el-dropdown-item>-->
          <el-dropdown-item @click.native="routerTo(1,0,'/user/user_info')">个人资料</el-dropdown-item>
          <el-dropdown-item @click.native="routerTo(1,0,'/user/update_password')">修改密码</el-dropdown-item>
<!--          <el-dropdown-item @click.native="changeUpload">{{uploadType}}</el-dropdown-item>-->
          <el-dropdown-item @click.native="outLogin">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
  import {OutLogin} from "../../api/user";
  import router from "../../router";

  export default {
    name: "LeftHeaderMenu",
    data(){
      return {
        uploadType:'外面',
      }
    },
    mounted() {
      // let _host = 'http://cc.gamebrain.io/uploads/'
      // if (localStorage.getItem('is_int')==='1'){
      //   _host = 'http://192.168.3.166/uploads/'
      //   this.uploadType = ' 公司'
      // }
      // console.log(_host)
      // this.$store.commit('setSourceHost', _host)
    },
    methods:{
      changeUpload(){
        if (localStorage.getItem('is_int')==='1'){
          localStorage.setItem('is_int',0)
        }else{
          localStorage.setItem('is_int',1)
        }
        this.$router.go(0)
      },
      routerTo(key,value,url=""){
        if (url!==""){
          this.$router.push({ path: url }).catch(err => err)
        }
        if (key===1){
          this.menuItem =  this.$store.state.menu.find(item=>item.id===value)
          this.$store.commit('setShowMenu',0)
          if (this.menuItem!==undefined){
            let child = this.menuItem.child.filter(item => item.is_show===1)
            if (child.length!==0){
              this.$store.commit('setShowMenu',1)
            }
          }
        }
      },
      outLogin(){
        OutLogin({}).then(resp => {
          if (resp.code===200){
            this._set_login('','')
            this.$message.success(resp.message)
            window.location = '/'
          }
        })
      }
    },
  }
</script>

<style scoped>
  .my-header-menu{
    height: 70px;
    margin: 0 auto;
  }
  .my-header-menu-left{
    float: left;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .logo{
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .my-header-menu-right{
    float: right;
    height: 100%;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/LeftHeaderMenu.vue